import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import { ItemAdjustment } from '../../../../../../domains/checkout/CartSummary/CartSummary.propTypes';
import { ImagePropType } from '../../../../../../services/proptypes';
import { getComponentForAdjustment } from '../../CartAdjustments.utils';
import './CartAdjustment.css';
var defaultProps = {
  photo: ''
};
export default function CartAdjustment(_ref) {
  var name = _ref.name,
    photo = _ref.photo,
    price = _ref.price,
    adjustment = _ref.adjustment,
    onRemoveItemProp = _ref.onRemoveItem;
  if (_isEmpty(name)) {
    return null;
  }
  var field = adjustment.field,
    uuid = adjustment.object_id;
  var AdjustmentComponent = getComponentForAdjustment(field);
  if (_isEmpty(AdjustmentComponent)) {
    return null;
  }
  function onRemoveItem() {
    return _onRemoveItem.apply(this, arguments);
  }
  function _onRemoveItem() {
    _onRemoveItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", onRemoveItemProp(uuid));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onRemoveItem.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Grid, {
    className: "cart-adjustment"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    className: "image",
    width: 2
  }, !_isEmpty(photo) && /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "image",
    src: photo
  }))), /*#__PURE__*/React.createElement(Grid.Column, {
    className: "name",
    width: 6
  }, name), /*#__PURE__*/React.createElement(Grid.Column, {
    className: "adjustment",
    width: 8
  }, /*#__PURE__*/React.createElement(AdjustmentComponent, {
    adjustment: adjustment,
    onRemoveItem: onRemoveItem,
    price: price
  })));
}
CartAdjustment.defaultProps = defaultProps;